import { ScrollShadow as HeroUiScrollShadow } from '@heroui/scroll-shadow';

export const ScrollShadow = HeroUiScrollShadow;
